import React from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { IconButton, Tooltip } from '@material-ui/core';
import HeaderIcon from '@material-ui/icons/Title';

import { createChart } from '../../../../events';

const messages = defineMessages({
  ADD_HEADER: {
    id: 'ADD_HEADER',
    defaultMessage: 'Add header',
  },
  NEW_HEADER: {
    id: 'NEW_HEADER',
    defaultMessage: 'New Header',
  },
});

function AddHeaderBtn({ intl }) {
  const dispatch = useDispatch();

  return (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.ADD_HEADER} />}>
      <IconButton onClick={() => dispatch(createChart('Header', null, null, null, intl, messages))}>
        <HeaderIcon />
      </IconButton>
    </Tooltip>
  );
}

export default injectIntl(AddHeaderBtn);
